import React from 'react';
import './ShowroomTabs.scss';

export type ShowroomTab = 'all' | string;

interface ShowroomTabsProps {
  selectedTab: ShowroomTab;
  onTabChange: (tab: ShowroomTab) => void;
  tabs: { id: string; label: string; count: number }[];
}

const ShowroomTabs: React.FC<ShowroomTabsProps> = ({ selectedTab, onTabChange, tabs }) => {

  return (
    <div className="showroom-tabs">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          className={`showroom-tabs__tab ${selectedTab === tab.id ? 'showroom-tabs__tab--active' : ''}`}
          onClick={() => onTabChange(tab.id)}
        >
          {`${tab.label} (${tab.count})`}
        </button>
      ))}
    </div>
  );
};

export default ShowroomTabs;
